import * as React from "react";
import { Divider, Modal, Space, Image, Row, Col } from "antd";
import { BrowserView, MobileView } from "react-device-detect";

import * as String from "../../commons/string";
import * as TypeDTO from "../../commons/typeDTO";

import ImgStep1 from "../../assets/images/home/rent/img_info_step1.png";
import ImgStep2 from "../../assets/images/home/rent/img_info_step2.png";
import ImgStep3 from "../../assets/images/home/rent/img_info_step3.png";
import ImgStep4 from "../../assets/images/home/rent/img_info_step4.png";
import ImgStep5 from "../../assets/images/home/rent/img_info_step5.png";

import ImgStepPC1 from "../../assets/images/home/rent/img_info_pc_step1.png";
import ImgStepPC2 from "../../assets/images/home/rent/img_info_pc_step2.png";
import ImgStepPC2B2B from "../../assets/images/home/rent/img_info_pc_step2_b2b.png";
import ImgStepPC3 from "../../assets/images/home/rent/img_info_pc_step3.png";
import ImgStepPC3B2B from "../../assets/images/home/rent/img_info_pc_step3_b2b.png";
import ImgStepPC4 from "../../assets/images/home/rent/img_info_pc_step4.png";
import ImgStepPC5 from "../../assets/images/home/rent/img_info_pc_step5.png";
import IconArrow from "../../assets/images/home/rent/icon_arrow_next.png";

import BgTableHeader from "../../assets/images/home/rent/bg_table_header.png";
import RadiusMap from "../../assets/images/home/rent/radius_map.jpg";
import UsageCard from "../../component/rent/UsageCard";
import RentPlaceMap from "./RentPlaceMap";
import KakaoMap from "../KakaoMap";

type showType = {
    show?: boolean;
    showTitle?: boolean;
    showDivider?: boolean;
    className?: string;
};

const Info = ({
    isB2b,
    carType,
    showInfo,
    showPlace,
    showCondition,
    showMethod,
    showInsurance,
    showMap,
    rentRegion,
    legal,
}: {
    isB2b?: boolean;
    carType?: string;
    showInfo?: showType;
    showPlace?: showType;
    showCondition?: showType;
    showInsurance?: showType;
    showMethod?: showType;
    showMap?: showType;
    rentRegion?: TypeDTO.RentRegionDto;
    legal?: boolean;
}) => {
    const dieselType = "디젤(3인승)";
    const usageInfos = [
        {
            color: "#88A4DB",
            image: ImgStep1,
            pcImage: ImgStepPC1,
            title: "상품 예약",
            description: "예약 화면에서 상품 예약 및 결제",
        },
        {
            color: "#587BBF",
            image: ImgStep2,
            pcImage: ImgStepPC2,
            title: "사전체크",
            description: "[계정]>[예약내역]>[사전체크] 두가지 체크 완료",
        },
        {
            color: "#284888",
            image: ImgStep3,
            pcImage: ImgStepPC3,
            title: "차고지 방문",
            description: "이용 당일 차고지 방문 후 관리자와 연락",
        },
        {
            color: "#082153",
            image: ImgStep4,
            title: "차량 무인 출차",
            pcImage: ImgStepPC4,
            description: "차량 상태 확인 및 비품 수령 후 출차",
        },
        {
            color: "#001236",
            image: ImgStep5,
            title: "차량 무인 반납",
            pcImage: ImgStepPC5,
            description: "차고지 도착 후 관리자와 연락하여 반납",
        },
    ];

    const usageInfosB2bType = [
        {
            color: "#88A4DB",
            image: ImgStep1,
            pcImage: ImgStepPC1,
            title: "상품 예약",
            description: "예약 화면에서 상품 예약",
        },
        {
            color: "#587BBF",
            image: ImgStep3,
            pcImage: ImgStepPC2,
            title: "차고지 방문",
            description: "이용 당일 차고지 방문",
        },
        {
            color: "#284888",
            image: ImgStep2,
            pcImage: ImgStepPC3B2B,
            title: "안내문 확인",
            description: "차량 내 안내문 확인",
        },
        {
            color: "#082153",
            image: ImgStep4,
            pcImage: ImgStepPC4,
            title: "차량 출차",
            description: "캠핑카 무인 출차",
        },
        {
            color: "#001236",
            image: ImgStep5,
            pcImage: ImgStepPC5,
            title: "차량 반납",
            description: "반납 시간에 맞춰 캠핑카 무인 반납 및 청소",
        },
    ];

    const infos = [
        "차량 실내는 금연입니다.",
        "차량 내 냄새가 강한 음식 조리 행위(육류, 생선구이, 청국장 등)를 금지하며, 환기를 충분히 해주세요.",
        "사용하신 집기류는 깨끗하게 세척하고, 물기를 제거한 뒤 반납함에 넣어주세요.",
        "발생한 쓰레기 및 이물질은 직접 수거 또는 처리 후 반납해 주세요.(미처리 시 청소 비용 발생)",
        "반려동물 동반 이용을 엄격히 제한합니다.(쾌적한 환경 유지 및 알레르기 예방 차원)",
        "각종 차량법규 위반에 따른 범칙금 및 과태료는 이용자에게 부과됩니다.",
        "렌트 잔여 시간 및 잔여 기간에 대하여 환불이 되지 않습니다.",
        "모든 비품은 사용 후 제자리에 놓아주세요.(차량 내 안내문 참고)",
    ];

    const infosB2bType = [
        "셀프 청소가 원칙입니다. 이용 후 직접 청소해 주세요.(차량 내 안내문 참고)",
        "반려동물 동반 이용을 엄격히 제한합니다.(쾌적한 환경 유지 및 알레르기 예방 차원)",
        "차량 실내는 금연입니다.",
        "차량 내 냄새가 강한 음식 조리 행위를 금지하며, 환기를 충분히 해주세요.",
        "모든 비품은 사용 후 제자리에 놓아주세요.",
        "각종 차량법규 위반에 따른 범칙금 및 과태료는 이용자에게 부과됩니다.",
        "다음 이용객을 위해 이용 시간은 반드시 지켜주세요.",
        "전 임직원 공용 복지 차량으로, 독점 예약은 제한하며 관리자에 의해 조정될 수 있습니다.",
    ];

    const conditions = ["대여 연령 : 만 26세 이상", "운전면허 : 1종 보통 이상, 1종 오토", "운전경력 : 2년 이상", "예약자 동행, 운전자 면허증 지참 필수"];

    const conditionsB2bType = ["대여 연령 : 만 26세 이상", "운전면허 : 1종 보통 이상, 1종 오토", "운전경력 : 2년 이상"];

    const conditionsB2bDieselType = ["대여 연령 : 만 26세 이상", "운전면허 : 1종 보통 이상", "운전경력 : 2년 이상"];

    const guaranteeInfos = [
        {
            th: "대인배상 I",
            td: "자배법에서 정한 금액",
        },
        {
            th: "대인배상 II",
            td: "무한",
        },
        {
            th: "대물배상",
            td: "1억",
        },
        {
            th: "자기신체사고",
            td: "사망 (인당) 3000만원\n부상 (인당) 1500만원\n장애 (인당) 3000만원",
        },
        {
            th: "차량손해",
            td: "9,713만원\n자기부담금:손해액외20%\n(최저 50만원, 최고 50만원)",
        },
    ];

    const guaranteeInfosB2bDieselType = [
        {
            th: "대인배상",
            td: "무한(1인당), 의무:자배법에서 정한금액",
        },
        {
            th: "대물배상",
            td: "5억원한도(1사고당)",
        },
        {
            th: "자동차상해",
            td: "사망/후유장애 1억원 한도(1인당)\n부상 3천만원 한도(1인당)",
        },
        {
            th: "무보험차상해",
            td: "5억원한도(1인당)",
        },
        {
            th: "자기차량손해",
            td: "가입금액:1,274만원\n자기부담금: 피보험자자동차 손해액의 20%\n(20만원~50만원)",
        },
    ];

    const noInsurance = ["만 26세 미만 보험 적용 불가", "명시되지 않은 부분에 대한 내용은 보험 약관에 따라 처리"];

    const warning = () => {
        Modal.warning({
            centered: true,
            title: "초과 반경 위약금",
            content: (
                <Space direction="vertical" size={10}>
                    <Image width="100%" src={RadiusMap} />
                    <p style={{ marginBottom: 0 }}>
                        차고지 기준 반경 50km 이내로 이용하실 수 있으며, 초과 시 초과 범위에 따라 위약금이 발생됩니다. (반경 50km 지역 이탈시 위약금 20만원,
                        이후 10km 당 10만원씩 추가 부과)
                    </p>
                </Space>
            ),
            okText: String.confirm,
            onOk() {},
        });
    };

    return (
        <>
            <MobileView className="mobile">
                {showInfo?.show && (
                    <div className={showInfo.className}>
                        {showInfo.showTitle && <h5 className="mb-3">{String.useInstruction}</h5>}
                        <ul style={{ paddingLeft: legal ? 0 : 20 }} className="mb-0 listSpace">
                            {isB2b ? infosB2bType.map((info) => <li key={info}>{info}</li>) : infos.map((info) => <li key={info}>{info}</li>)}
                        </ul>
                        {showInfo.showDivider && <Divider style={{ margin: "30px 0" }} />}
                    </div>
                )}
                {showPlace?.show && isB2b && (
                    <div className={showPlace.className}>
                        {showPlace.showTitle && <h5 className="text-center mb-3">이용 장소</h5>}
                        <ul style={{ paddingLeft: legal ? 0 : 20 }} className="mb-0 listSpace">
                            <li className="mb-3">일정 기간 동안 이용 장소를 두 곳으로 한정합니다. 이용 장소 제한이 풀릴 경우 별도 공지하도록 하겠습니다.</li>
                        </ul>
                        <KakaoMap
                            mapCenter={{
                                lat: 35.6722497693807,
                                lng: 128.371195584448,
                            }}
                            mapStyle={{ aspectRatio: "5/3" }}
                        />
                        <ul style={{ paddingLeft: legal ? 0 : 20 }} className="mb-0 mt-3 listSpace">
                            <li className="mt-1 mb-3">
                                강변오토캠핑장 예약 후 이용해 주세요.{" "}
                                <a href="https://yeyak.dssiseol.or.kr/index.do?menu_id=00005190&servletPath=%2Findex.do" target="_blank" rel="noreferrer">
                                    예약링크
                                </a>
                            </li>
                        </ul>
                        <KakaoMap
                            mapCenter={{
                                lat: 35.9186366584404,
                                lng: 128.611496244201,
                            }}
                            mapStyle={{ aspectRatio: "5/3" }}
                        />
                        <ul style={{ paddingLeft: legal ? 0 : 20 }} className="mb-0 mt-3 listSpace">
                            <li className="mt-1 mb-3">
                                금호강오토캠핑장 예약 후 이용해 주세요.{" "}
                                <a href="https://yeyak.daegu.go.kr/yeyak/camp/campListView.do?memId=B0000054" target="_blank" rel="noreferrer">
                                    예약링크
                                </a>
                            </li>
                        </ul>
                        {showPlace.showDivider && <Divider style={{ margin: "30px 0" }} />}
                    </div>
                )}
                {showCondition?.show && (
                    <div className={showCondition.className}>
                        {showCondition.showTitle && <h5 className="text-center mb-3">대여 조건</h5>}
                        <ul style={{ paddingLeft: legal ? 0 : 20 }} className="mb-0 listSpace">
                            {isB2b
                                ? carType === dieselType
                                    ? conditionsB2bDieselType.map((condition) => (
                                          <li className="mb-1" key={condition}>
                                              {condition}
                                          </li>
                                      ))
                                    : conditionsB2bType.map((info) => <li key={info}>{info}</li>)
                                : conditions.map((condition) => (
                                      <li className="mb-1" key={condition}>
                                          {condition}
                                      </li>
                                  ))}
                            <li className="text-danger" style={{ listStyle: "none" }}>
                                ※조건에 적합하지 않을 경우 대여 불가
                            </li>
                        </ul>
                        {showCondition.showDivider && <Divider style={{ margin: "30px 0" }} />}
                    </div>
                )}
                {showMap?.show && rentRegion && (
                    <div className={showMap.className}>
                        {showMap.showTitle && <h5 className="text-center">대여 장소</h5>}
                        <RentPlaceMap place={rentRegion} />
                        {isB2b ? (
                            <>
                                <ul style={{ paddingLeft: legal ? 0 : 20 }} className="mb-0 mt-3 listSpace">
                                    <li>출차 : 오후 2시 이후</li>
                                    <li>반납 : 오전 11시까지</li>
                                    <li>{carType === dieselType ? "연료(경유)는 FULL 충전 후 반납" : "배터리 90% 이상 충전 후 반납"}</li>
                                </ul>
                            </>
                        ) : (
                            <>
                                <ul style={{ paddingLeft: legal ? 0 : 20 }} className="mb-0 mt-3 listSpace">
                                    <li>출차 : 오후 2시 ~ 오후 5시(시간 외 출차 불가)</li>
                                    <li>반납 : 반납일 오전 11시까지</li>
                                    <li>반납 시 배터리는 출차 수준으로 충전해 주세요. 미충전 시 비용이 청구됩니다.</li>
                                    <li>
                                        차고지 기준 반경 50km 이내로 이용하실 수 있으며, 초과 시 초과 범위에 따라 위약금이 발생됩니다.
                                        <span style={{ color: "rgb(0, 95, 219)", fontWeight: "bold", marginLeft: 8, cursor: "pointer" }} onClick={warning}>
                                            자세히 보기
                                        </span>
                                    </li>
                                </ul>
                                <div className="custom-bolder-box mb-4 mt-3">
                                    <p className="text-danger text-bold">※ {String.caution}</p>
                                    <ul className="listSpace mb-0 mt-2">
                                        <li>출차와 반납시간은 반드시 지켜주세요. (이른 반납은 관리자 협의 필요)</li>
                                        <li>배터리 충전량이 출차 상태보다 부족할 경우 충전요금이 부과됩니다. (1%당 600원 부과)</li>
                                    </ul>
                                </div>
                            </>
                        )}
                        {showMap.showDivider && <Divider style={{ margin: "30px 0" }} />}
                    </div>
                )}
                {showMethod?.show && (
                    <div className={showMethod.className}>
                        {showMethod.showTitle && <h5 className="text-center mb-3">이용 방법</h5>}
                        <UsageCard values={isB2b ? usageInfosB2bType : usageInfos} />
                        {!isB2b && (
                            <div className="custom-bolder-box mb-4 mt-3">
                                <p className="text-danger text-bold">※ {String.caution}</p>
                                <ul className="listSpace mb-0 mt-2">
                                    <li>출차와 반납은 무인으로 진행되므로, 차고지 도착 시 반드시 관리자에게 연락해 주세요.(070-4327-3730)</li>
                                    <li>차량 상태 확인을 위해, 전면·후면·측면 등 차량 전체가 잘 보이도록 최소 6장의 사진을 촬영해 주세요.</li>
                                </ul>
                            </div>
                        )}
                        {showMethod.showDivider && <Divider style={{ margin: "30px 0" }} />}
                    </div>
                )}
                {showInsurance?.show && (
                    <div className={showInsurance.className}>
                        {showInsurance.showTitle && <h5 className="text-center mb-3">보험 안내</h5>}
                        <div className="mb-4">
                            <ul style={{ paddingLeft: legal ? 0 : 20 }} className="mb-0 listSpace">
                                {!isB2b && (
                                    <li className="mb-2">
                                        자차보험은 필수 가입 항목으로 예약 시 1박당 1만원으로 정산합니다. (본인 외 운전자 1인 무료 추가 가능)
                                    </li>
                                )}
                                <li>
                                    자차 보험은 아래와 같습니다.
                                    <br />
                                    {carType === dieselType
                                        ? "1) 자기 부담금 손해액의 20%(20만원~50만원)"
                                        : "1) 자기 부담금 손해액외20%(최저 50만원, 최고 50만원)"}
                                </li>
                            </ul>
                        </div>
                        <table className="table design-table">
                            <thead style={{ backgroundImage: `url(${BgTableHeader})`, backgroundSize: "cover", border: "none" }}>
                                <tr>
                                    <th colSpan={2} className="text-center">
                                        담보 및 가입금액
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {carType === dieselType
                                    ? guaranteeInfosB2bDieselType.map((info) => (
                                          <tr key={info.th}>
                                              <th style={{ textAlign: "left" }}>{info.th}</th>
                                              <td style={{ textAlign: "right" }}>{info.td}</td>
                                          </tr>
                                      ))
                                    : guaranteeInfos.map((info) => (
                                          <tr key={info.th}>
                                              <th style={{ textAlign: "left" }}>{info.th}</th>
                                              <td style={{ textAlign: "right" }}>{info.td}</td>
                                          </tr>
                                      ))}
                            </tbody>
                        </table>
                        <div className="custom-bolder-box">
                            <p className="pb-2 text-danger text-bold">※ 보험 처리가 되지 않는 경우</p>
                            <ul className="listSpace mb-0">
                                {noInsurance.map((insurance) => (
                                    <li key={insurance}>{insurance}</li>
                                ))}
                            </ul>
                        </div>
                        {showInsurance.showDivider && <Divider style={{ margin: "30px 0" }} />}
                    </div>
                )}
            </MobileView>
            <BrowserView className="browser">
                {showInfo?.show && (
                    <div className={showInfo.className}>
                        {showInfo.showTitle && <h5 className="mb-4">{String.useInstruction}</h5>}
                        <ul className="listSpace">
                            {isB2b ? infosB2bType.map((info) => <li key={info}>{info}</li>) : infos.map((info) => <li key={info}>{info}</li>)}
                        </ul>
                        {showInfo.showDivider && <Divider />}
                    </div>
                )}
                {showPlace?.show && isB2b && (
                    <div className={showPlace.className}>
                        {showPlace.showTitle && <h5 className="text-center mb-4">이용 장소</h5>}
                        <ul className="listSpace">
                            <li>일정 기간 동안 이용 장소를 두 곳으로 한정합니다. 이용 장소 제한이 풀릴 경우 별도 공지하도록 하겠습니다.</li>
                        </ul>
                        <Row gutter={16}>
                            <Col span={12}>
                                <KakaoMap
                                    mapCenter={{
                                        lat: 35.6722497693807,
                                        lng: 128.371195584448,
                                    }}
                                    mapStyle={{ aspectRatio: "5/3" }}
                                />
                                <ul className="listSpace">
                                    <li>
                                        강변오토캠핑장 예약 후 이용해 주세요.{" "}
                                        <a
                                            href="https://yeyak.dssiseol.or.kr/index.do?menu_id=00005190&servletPath=%2Findex.do"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            예약링크
                                        </a>
                                    </li>
                                </ul>
                            </Col>
                            <Col span={12}>
                                <KakaoMap
                                    mapCenter={{
                                        lat: 35.9186366584404,
                                        lng: 128.611496244201,
                                    }}
                                    mapStyle={{ aspectRatio: "5/3" }}
                                />
                                <ul className="listSpace">
                                    <li>
                                        금호강오토캠핑장 예약 후 이용해 주세요.{" "}
                                        <a href="https://yeyak.daegu.go.kr/yeyak/camp/campListView.do?memId=B0000054" target="_blank" rel="noreferrer">
                                            예약링크
                                        </a>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                        {showPlace.showDivider && <Divider />}
                    </div>
                )}
                {showCondition?.show && (
                    <div className={showCondition.className}>
                        {showCondition.showTitle && <h5 className="text-center mb-4">대여 조건</h5>}
                        <ul style={{ paddingLeft: legal ? 0 : 20 }} className="mb-0 listSpace">
                            {isB2b
                                ? carType === dieselType
                                    ? conditionsB2bDieselType.map((info) => <li key={info}>{info}</li>)
                                    : conditionsB2bType.map((info) => <li key={info}>{info}</li>)
                                : conditions.map((info) => <li key={info}>{info}</li>)}

                            <li className="text-danger" style={{ listStyle: "none", marginLeft: -20 }}>
                                ※조건에 적합하지 않을 경우 대여 불가
                            </li>
                        </ul>
                        {showCondition.showDivider && <Divider />}
                    </div>
                )}
                {showMap?.show && rentRegion && (
                    <div className={showMap.className}>
                        {showMap.showTitle && <h5 className="text-center mb-4">대여 장소</h5>}
                        <RentPlaceMap place={rentRegion} />
                        {isB2b ? (
                            <>
                                <ul className="listSpace mt-3">
                                    <li>출차 : 오후 2시 이후</li>
                                    <li>반납 : 오전 11시까지</li>
                                    <li>{carType === dieselType ? "연료(경유)는 FULL 충전 후 반납" : "배터리 90% 이상 충전 후 반납"}</li>
                                </ul>
                            </>
                        ) : (
                            <>
                                <ul className="listSpace mt-3">
                                    <li>출차 : 오후 2시 ~ 오후 5시(시간 외 출차 불가)</li>
                                    <li>반납 : 반납일 오전 11시까지</li>
                                    <li>반납 시 배터리는 출차 수준으로 충전해 주세요. 미충전 시 비용이 청구됩니다.</li>
                                    <li>
                                        차고지 기준 반경 50km 이내로 이용하실 수 있으며, 초과 시 초과 범위에 따라 위약금이 발생됩니다.
                                        <span style={{ color: "rgb(0, 95, 219)", fontWeight: "bold", marginLeft: 8, cursor: "pointer" }} onClick={warning}>
                                            자세히 보기
                                        </span>
                                    </li>
                                </ul>
                                <div className="custom-bolder-box mb-2 mt-3">
                                    <p className="text-danger text-bold">※ 유의사항</p>
                                    <ul className="listSpace mb-0">
                                        <li>출차와 반납시간은 반드시 지켜주세요. (이른 반납은 관리자 협의 필요)</li>
                                        <li>배터리 충전량이 출차 상태보다 부족할 경우 충전요금이 부과됩니다. (1%당 600원 부과)</li>
                                    </ul>
                                </div>
                            </>
                        )}
                    </div>
                )}
                {showMethod?.show && (
                    <div className={showMethod.className}>
                        {showMethod.showTitle && <h5 className="text-center mb-4">이용 방법</h5>}
                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                            {isB2b
                                ? usageInfosB2bType.map((info, index) => (
                                      <div style={{ display: "flex", justifyContent: "space-around", width: "20%", textAlign: "center" }} key={info.title}>
                                          <div className="text-center">
                                              <img className="mb-1" src={info.pcImage} width={110} />
                                              <p>{info.description}</p>
                                          </div>
                                      </div>
                                  ))
                                : usageInfos.map((info, index) => (
                                      <div style={{ display: "flex", justifyContent: "space-around", width: "20%", textAlign: "center" }} key={info.title}>
                                          <div className="text-center">
                                              <img className="mb-1" src={info.pcImage} width={110} />
                                              <p>{info.description}</p>
                                          </div>
                                      </div>
                                  ))}
                        </div>
                        {!isB2b && (
                            <div className="custom-bolder-box mb-2 mt-3">
                                <p className="text-danger text-bold">※ 유의사항</p>
                                <ul className="listSpace mb-0">
                                    <li>출차와 반납은 무인으로 진행되므로, 차고지 도착 시 반드시 관리자에게 연락해 주세요.(070-4327-3730)</li>
                                    <li>차량 상태 확인을 위해, 전면·후면·측면 등 차량 전체가 잘 보이도록 최소 6장의 사진을 촬영해 주세요.</li>
                                </ul>
                            </div>
                        )}
                        {showMethod.showDivider && <Divider />}
                    </div>
                )}
                {showInsurance?.show && (
                    <div className={showInsurance.className}>
                        <>
                            {showInsurance.showTitle && <h5 className="text-center mb-4">보험 안내</h5>}
                            <ul>
                                {!isB2b && (
                                    <li className="mb-2">
                                        자차보험은 필수 가입 항목으로 예약 시 1박당 1만원으로 정산합니다. (본인 외 운전자 1인 무료 추가 가능)
                                    </li>
                                )}
                                <li>
                                    자차 보험은 아래와 같습니다.
                                    <br />
                                    1) 자기 부담금 손해액외20%(최저 50만원, 최고 50만원)
                                </li>
                            </ul>
                        </>
                        <table className="table design-table mt-3">
                            <thead style={{ backgroundImage: `url(${BgTableHeader})`, backgroundSize: "cover", border: "none" }}>
                                <tr>
                                    <th colSpan={2} className="text-center">
                                        담보 및 가입금액
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {carType === dieselType
                                    ? guaranteeInfosB2bDieselType.map((info) => (
                                          <tr key={info.th}>
                                              <th style={{ textAlign: "left" }}>{info.th}</th>
                                              <td style={{ textAlign: "right" }}>{info.td}</td>
                                          </tr>
                                      ))
                                    : guaranteeInfos.map((info) => (
                                          <tr key={info.th}>
                                              <th style={{ textAlign: "left" }}>{info.th}</th>
                                              <td style={{ textAlign: "right" }}>{info.td}</td>
                                          </tr>
                                      ))}
                            </tbody>
                        </table>
                        <div className="custom-bolder-box">
                            <p className="text-danger text-bold">※ 보험 처리가 되지 않는 경우</p>
                            <ul className="mb-0">
                                {noInsurance.map((insurance) => (
                                    <li key={insurance}>{insurance}</li>
                                ))}
                            </ul>
                        </div>
                        {showInsurance.showDivider && <Divider />}
                    </div>
                )}
            </BrowserView>
        </>
    );
};

export default Info;
